import React from "react";
import styled from "styled-components";
// Style the Button component

const Button = styled.button`
  width: 227px;
  height: 55px;
  align-self: flex-start;
  background: ${(props) => (props.active === true ? "#00297A" : "#E0E1E2")};
  color: ${(props) => (props.active === true ? "#FFFFFF" : "#00000099")};
  border: 2px solid transparent;
  border-radius: 7px;
  font: normal normal 700 18px Poppins;
  font-weight: 700;
  text-align: center;
  padding: 0;
  &:hover {
    background: #00187e;
    color: #ffffff;
  }
`;

const FileUploader = (props) => {
  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef(null);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];

    var reader = new FileReader();
    reader.readAsDataURL(fileUploaded);
    reader.onload = function () {
      props.handleFile(reader.result.split(";base64,")[1]);
    };
    reader.onerror = function (error) {
      console.error("Error: ", error);
    };
  };

  return (
    <>
      <Button onClick={handleClick}>{props.label}</Button>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: "none" }}
      />
    </>
  );
};

export default FileUploader;
